module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar fieldConfig = (model || {}).config || {};\nvar resourceAttributes = (resourceData || {}).attributes || {}\nvar startTS = resourceAttributes.sendingStartedAt || resourceAttributes.sendDateTime || false;\nif(startTS !== false) {\nstartTS = utils.moment(startTS).format(fieldConfig.momentDateFormat || 'dd.mm.yyyy');\n} else {\nstartTS = '-';\n}\n%>\n<div><%= startTS %></div>"
  , __filename = "components/templates/newsletter/subscribers/table/fields/startTS.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fieldConfig = (model || {}).config || {};
var resourceAttributes = (resourceData || {}).attributes || {}
var startTS = resourceAttributes.sendingStartedAt || resourceAttributes.sendDateTime || false;
if(startTS !== false) {
startTS = utils.moment(startTS).format(fieldConfig.momentDateFormat || 'dd.mm.yyyy');
} else {
startTS = '-';
}

    ; __line = 10
    ; __append("\n<div>")
    ; __line = 11
    ; __append(escapeFn( startTS ))
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/subscribers/table/fields/startTS.ejs

}